<template>
<div>
  <b-container >
    <div class="user-address-container"> 
      <b-tabs fill>
        <b-tab  active>
          <template v-slot:title>
            {{'userAddressTabMain' | localize}} 
          </template>          
          <UserBill></UserBill>
        </b-tab>
        <b-tab title="Расчет">
          <template v-slot:title>
            {{'userAddressTabBills' | localize}} 
          </template>             
          <Invoice></Invoice>
        </b-tab>
      </b-tabs>
    </div>
  </b-container>
</div>

</template>
<script>
import UserBill from './UserBills'
import Invoice from './Invoice'
import { mapGetters } from 'vuex'
export default {
  name: 'UserAddress',
  data: ()=> ({
    user_data: []
  }),
  computed: mapGetters(['userInfoData']),
  mounted(){
    this.user_data = this.$store.getters.userInfoData
  },

  components: { UserBill, Invoice },
}
</script>
